import styled from "styled-components";
import { Row } from "core/styles";
import { motion } from "framer-motion";
import { dh_colors } from "theme";

export const StyledLabel = styled.span`
  font-family: Source Code Pro;
  font-weight: 500;
  line-height: 24px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledValue = styled.span`
  font-family: Source Code Pro;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //   margin-bottom: 5px;
`;

export const ComboButton = styled.div`
  color: #000000;
  font-family: "Inter";
  font-size: 14px;
  line-height: 14px;
  background-color: #ffffff;
  border: 1px solid #dddbda;
  padding: 6px 18px;
  width: fit-content;
  cursor: pointer;

  &:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  &:nth-child(2) {
  }

  &:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }

  &:hover {
    background-color: #9f9f9f;
    border-color: #9f9f9f;
    color: #ffffff;
  }

  ${(props) =>
    props.isActive &&
    `
    color: #ffffff;
    background-color: #2f2e41;
    border-color: #2f2e41;

    &:hover {
      color: #ffffff;
      background-color: #2f2e41;
      border-color: #2f2e41;
    }
  `}
`;

export const StyledTab = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  min-width: 145px;
  text-align: center;
  font-size: 16px;
  line-height: 18px;
  background-color: #ffffff;
  color: #541299;
  cursor: pointer;
  padding: 11px 16px;

  &:hover {
    background-color: #ddcdef;
  }

  ${(props) =>
    props.selected &&
    `
      background-color: #541299;
      color: #ffffff;
      cursor: default;

      &:hover {
        background-color: #6d36a5;
        color: #ffffff;
      }
  `}
`;

export const SettingLabel = styled.div`
  display: block;
  margin: 0px;
  margin-bottom: 10px;
  color: #000000;
  font-family: "Inter";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 18px;
  margin-bottom: 4px;
`;

export const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  padding-bottom: 7px;
`;

export const QueryStructure = styled.div`
  .queryContainer > div:first-child {
    position: relative;
    right: 5px;
  }

  .queryContainer .queryRule {
    position: relative;
    display: flex;
    flex-wrap: wrap;
  }

  .queryContainer .queryRule:before {
    border-color: ${dh_colors.grey_60};
    border-width: 0 0 1px 1px;
    content: "";
    width: 15px;
    left: calc(-0.5rem - 8px);
    border-style: solid;
    border-radius: 0;
    position: absolute;
  }

  .queryContainer .queryRule:after {
    border-color: ${dh_colors.grey_60};
    border-width: 0 0 0 1px;
    content: "";
    width: 15px;
    left: calc(-0.5rem - 8px);
    border-style: solid;
    border-radius: 0;
    position: absolute;
  }

  .queryContainer .queryGroupContainer:before {
    border-color: ${dh_colors.grey_60};
    border-width: 0 0 1px 1px;
    content: "";
    width: 15px;
    left: calc(-0.5rem - 9px);
    border-style: solid;
    border-radius: 0;
    position: absolute;
  }

  .queryContainer .queryGroupContainer:after {
    border-color: ${dh_colors.grey_60};
    border-width: 0 0 0 1px;
    content: "";
    width: 15px;
    left: calc(-0.5rem - 9px);
    border-style: solid;
    border-radius: 0;
    position: absolute;
  }

  .queryItemContainer .queryRule::before {
    top: -16px;
    height: 25px;
  }

  .queryItemContainer .queryRule::after {
    top: 10px;
    height: calc(100% + 0px);
  }

  .queryItemContainer .queryGroupContainer:before {
    top: -4px;
    height: 13px;
  }

  .queryItemContainer .queryGroupContainer:after {
    top: 10px;
    height: calc(100% + 0px);
  }

  .queryChildren > :last-child::before {
    border-bottom-left-radius: 4px;
  }

  .queryItemContainer > :last-child::before {
    border-bottom-left-radius: 4px;
  }

  .queryItemContainer .queryRule > :last-child::before {
    border-bottom-left-radius: 0.25rem;
  }

  .queryItemContainer > .queryRule:last-of-type::after {
    content: none !important;
  }

  .queryItemContainer > .queryGroupContainer:last-child::after {
    content: none !important;
  }

  .queryChildren > div:last-child::after {
    content: none !important;
  }

  .queryChildren > .queryGroupContainer:last-child::after {
    content: none !important;
  }

  .queryChildren > .queryGroupContainer:before {
    top: -11px;
    height: 25px;
  }

  .queryChildren .queryRule::before {
    top: -10px;
    height: 25px;
  }

  .queryGroup > div:first-child {
    position: relative;
    right: 5px;
  }
`;

export const QueryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 16px 17px 19px 14px;
  background-color: ${dh_colors.grey_20};
  border-radius: 5px;
  flex-wrap: wrap;
`;

export const QueryRow = styled.div`
  display: flex;
  gap: 5px;
`;
export const QueryChildren = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  gap: 10px;
  flex-wrap: wrap;
`;

export const QueryItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 11px;
  padding: 5px 17px 19px 20px;
  flex-wrap: wrap;
`;

export const QueryGroupContainer = styled.div`
  background-color: ${dh_colors.grey_40};
  border: 1px solid ${dh_colors.grey_60};
  border-radius: 5px;
  padding: 10px 17px 16px 15px;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 10px;
  flex-wrap: wrap;
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 552px;
  max-height: 280px;
  overflow: auto;
  border-top: solid 1px #dddbda;
  margin-bottom: 15px;
`;

export const ListItem = styled.div`
  padding: 10px 20px;
  font-size: 15px;
  line-height: 20px;
  color: #000000;
  border-bottom: solid 1px #dddbda;
  ${(props) => props.index % 2 === 0 && "background-color: #F3F2F2;"}
`;

export const ModalHeader = styled.div`
  color: #000000;
  font-family: "Inter";
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 0;
  padding: 0px;
  line-height: 1;
  padding-bottom: 15px;
`;

export const Card = styled(Row)`
  display: block;
  padding: 16px;
  min-height: fit-content;
  border-radius: 5px;
  border: 1px solid #898d8f;
  background-color: #ffffff;
  margin: 16px 0px;

  &:first-child {
    margin-top: 5px;
  }
`;

export const ProductBundle = styled.div`
  font: Inter;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
  color: #000000;
`;

export const SectionSeparator = styled.div`
  height: 1px;
  background-color: #dbdbdb;
`;

export const Product = styled.div`
  gap: 8px;
`;

export const ProductHeader = styled.div`
  display: flex;
  height: 20px;
  margin-top: 8px;
`;

export const ProductTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  width: 100%;
  color: #000000;

  > span {
    font-weight: 400;
  }
`;

export const ProductAttributes = styled.div`
  display: flex;
  padding: 8px 0px;
`;

export const CurrentChanges = styled.div`
  width: 45%;
  //   min-width: 45%;

  padding-right: 10px;
`;

export const Separator = styled.div`
  width: 10%;
  text-align: -webkit-center;
`;

export const SeparatorIcon = styled.div`
  width: 50px;
  height: 144px;
  aspect-ratio: 1/3;
  clip-path: polygon(0 0, 100% 50%, 0 100%);
  background: #d9d9d9;
`;

export const NewChanges = styled.div`
  //   width: 45%;
  min-width: 45%;
  padding-left: 10px;
`;

export const SummaryChanges = styled.div`
  width: 100%;
  padding-right: 10px;
`;

export const NotificationHeader = styled.div`
  text-align: center;
  background-color: #0097c0;
  color: #ffffff;
  font-weight: 600;
  font-size: 12px;
  height: fit-content;
  padding: 16px 36px;
  margin-bottom: 16px;

  //Animation using only transition effect
  /* opacity: ${(props) => (props.visible ? 1 : 0)};
  transform: ${(props) =>
    props.visible ? "translateY(0)" : "translateY(-10px)"};
  visibility: ${(props) => (props.visible ? "visible" : "hidden")};
  pointer-events: ${(props) => (props.visible ? "auto" : "none")};
  transition-delay: ${(props) => (props.visible ? "0.5s" : "0s")};

  // to remove the jerky disappearannce of text
  height: ${(props) => (props.visible ? "60px" : "0px")};
  padding: ${(props) => (props.visible ? "16px 36px" : "0px")};
  margin-bottom: ${(props) => (props.visible ? "16px" : "0px")};
  transition: opacity 0.5s ease-in-out, transform 0.5s ease-in-out,
    max-height 0.5s ease-in-out,
    visibility 0s linear ${(props) => (props.visible ? "0.5s" : "0s")};
  overflow: hidden; */
`;

// export const ScrollableMenu = styled(motion.div).attrs({ layoutScroll: true })`
export const ScrollableMenu = styled.div`
  height: 100%;
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  transition: scrollbar-color 150ms ease-in-out;
  scrollbar-color: hsl(265 66% 20% / 0.25) #f1eafb;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
  padding-right: 20px;
  padding-bottom: 20px;

  &:hover {
    scrollbar-color: hsl(265 66% 20% / 0.6) #f1eafb;
  }
`;

export const StyledCheckboxItem = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;

  span {
    font-size: 12px;
    font-family: "Inter";
    color: #2b2826;
    line-height: 100%;
  }
`;

export const StyledSelectAll = styled.input`
  font-size: 12px;
  font-family: "Inter";
  display: flex;
  align-items: center;
  position: absolute;
  color: #541299;
  line-height: 12px;

  height: 20px;
  width: 20px;
  opacity: 0;
`;

export const SelectAllIcon = styled.div`
  font-size: 12px;
  font-family: "Inter";
  display: flex;
  align-items: center;
  position: relative;
  line-height: 12px;

  box-sizing: border-box;
  height: 20px;
  width: 20px;
  border-radius: 4px;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  margin-right: 8px;

  svg {
    color: #ffffff;
    font-size: 14px;
  }
`;

export const HiddenElement = styled.div`
  margin-top: 15px;
  margin-left: 10px;
  margin-bottom: -15px;
`;

export const VisibleOnHoverContainer = styled.span`
  ${HiddenElement} {
    opacity: 0;
  }

  &:hover {
    ${HiddenElement} {
      display: block;
      opacity: 1;
    }
  }
`;

export const ViewJsonButton = styled.div`
  position: relative;
  margin-left: 10px;
  z-index: 100;
  cursor: pointer;

  & > svg {
    margin-left: 0px !important;

    :hover {
      background-color: #6842c0;
    }
  }
`;

export const JSONContainer = styled.div`
  text-align: left;
  background-color: #fff;
  font-family: Inter;
  letter-spacing: 0.6px;
  font-size: 16px;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 20px;
  max-height: 80vh;
  width: 100%;
  max-width: 100%;
  overflow: auto;
  font-weight: normal;

  .jstree-anchor {
    white-space: normal;
    height: auto;
  }
  .jstree-default .jstree-anchor {
    height: auto;
  }

  & * {
    white-space: normal !important;
  }

  & > ul {
    background-color: transparent !important;
  }
`;

//Product Tooltip styles
export const TooltipMenu = styled.div`
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
  max-width: 552px;
`;

export const HeaderPanel = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  max-width: 552px;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  gap: 4px;
`;

export const ScrollableContentPanel = styled.div`
  width: 100%;
  overflow-y: auto;
  transition: scrollbar-color 150ms ease-in-out;
  scrollbar-color: #f1eafb transparent;
  scrollbar-width: thin;

  &:hover {
    scrollbar-color: #f1eafb transparent;
  }
`;

export const ListPanel = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
`;

export const PanelContent = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;

export const ItemList = styled.ul`
  list-style-type: disc;
  padding-left: 15px;
  margin: 0px;
  max-width: 500px;
`;
